export function initContactForm() {
  const form = document.getElementById('contact-form');
  const result = document.getElementById('contact-result');
  const submitBtn = document.getElementById('contact-submit-btn');

  if (!form) return;

  // IMPORTANT: Add your Web3Forms Access Key here!
  // Get one for free at https://web3forms.com
  const WEB3FORMS_ACCESS_KEY = "5990b219-fd92-4070-a93c-6cb7378179f5";

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (WEB3FORMS_ACCESS_KEY === "YOUR_WEB3FORMS_ACCESS_KEY_HERE" || !WEB3FORMS_ACCESS_KEY) {
      showMessage("Please add your Web3Forms Access Key in src/js/contact.js to enable emails.", "error");
      return;
    }

    const formData = new FormData(form);
    const object = { access_key: WEB3FORMS_ACCESS_KEY };
    formData.forEach((value, key) => { object[key] = value; });

    // UI Update: loading state
    const originalBtnText = submitBtn.textContent;
    submitBtn.textContent = "Sending...";
    submitBtn.disabled = true;
    result.classList.remove('show', 'success', 'error');

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(object),
      });

      const json = await response.json();

      if (response.status === 200) {
        showMessage(json.message || "Message sent successfully!", "success");
        form.reset();
      } else {
        console.log(response);
        showMessage(json.message || "Something went wrong!", "error");
      }
    } catch (error) {
      console.log(error);
      showMessage("Something went wrong!", "error");
    } finally {
      submitBtn.textContent = originalBtnText;
      submitBtn.disabled = false;
    }
  });

  function showMessage(msg, type) {
    result.textContent = msg;
    result.className = `form-result show ${type}`;

    // Auto-hide after 5 seconds
    setTimeout(() => {
      result.classList.remove('show');
    }, 5000);
  }
}
